/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




// 获取所有<video>元素
document.querySelectorAll('video').forEach((videoElement) => {
  // 跳过包含 src 的 <video>（不修改）
  if (videoElement.hasAttribute('src')) {
    return;
  }

  // 读取原始controlslist并转换为videoid
  const controlsListValue = videoElement.getAttribute('controlslist');
  if (controlsListValue) {
    videoElement.removeAttribute('controlslist'); // 移除原来的controlslist
    videoElement.setAttribute('videoid', controlsListValue); // 设置videoid
  }

  // 添加playlabel
  videoElement.setAttribute('playlabel', "Play: Keynote (Google I/O '18)");

  // 获取videoid
  const videoid = videoElement.getAttribute('videoid');
  if (videoid) {
    // 创建<lite-youtube>元素
    const liteYoutubeElement = document.createElement('lite-youtube');
    liteYoutubeElement.setAttribute('videoid', videoid);

    // 替换原来的<video>元素
    videoElement.parentNode.replaceChild(liteYoutubeElement, videoElement);
  }
});



//将页面中的<video>修改为<lite-youtube>避免shopify过滤<lite-youtube>元素。



//----------------------要求巴西客户提供CPF-------------------------------------
// 检查本地存储中是否已经存在 CPF 号码
var storedCPF = localStorage.getItem("cpfNumber");
console.log('cpf', storedCPF);



// 如果本地存储中不存在 CPF 号码
if (!storedCPF) {
    // 定义一个函数，用于弹出输入框要求输入 CPF 号码
    function promptCPF() {
        var cpfInput = prompt("Por favor, preencha seu número CPF porque a alfândega brasileira precisa dele.");

        // 如果用户点击了确定按钮且输入了 CPF 号码
        if (cpfInput && cpfInput.trim().length >= 11) {
            // 保存 CPF 号码到本地存储
            localStorage.setItem('cpfNumber', cpfInput);
            alert('Número do CPF economizado com sucesso!');
        } else if (cpfInput === null) {
            // 用户取消输入时不做任何操作
        } else {
            alert('Por favor, digite o CPF correto.');
            // 重新调用输入函数
            promptCPF();
        }
    }

    // 检查是否存在 id 为 'shipping-estimator-country' 的元素
    var select = document.getElementById("shipping-estimator-country");

    if (select) {
        // 获取用户选择的国家
        var selectedCountry = select.options[select.selectedIndex].value;

        // 如果用户选择的是 Brazil，则弹出输入框要求输入 CPF 号码
        if (selectedCountry === 'Brazil') {
            promptCPF();
        }

        // 监听选择改变国家事件
        select.addEventListener("change", function() {
            // 延时1秒执行下面的代码
            setTimeout(function() {
                // 获取用户选择的国家
                var selectedCountry = select.options[select.selectedIndex].value;
                // 如果用户选择的是 Brazil，则弹出输入框要求输入 CPF 号码
                if (selectedCountry === 'Brazil') {
                    promptCPF();
                }
            }, 1000);
        });
    } else {
        console.log("Elemento 'shipping-estimator-country' não encontrado.");
    }
}

//----------------------要求巴西客户提供CPF-------------------------------------








// 使用ipinfo.io API获取IP相关的地理信息
fetch('https://ipinfo.io/json')
  .then(response => response.json())
  .then(data => {
    // 将获取到的字段构建为对象
    const info = {
      ip: data.ip,              // IP 地址
      city: data.city,          // 城市
      region: data.region,      // 省/州
      country: data.country,    // 国家
      loc: `https://www.google.com/maps/place/${data.loc}`,            // 经纬度
      org: data.org,            // 组织
      postal: data.postal,      // 邮政编码
      timezone: data.timezone,  // 时区
      page: window.location.href // 当前页面链接
    };

    // 获取浏览器指纹
    const fpPromise = import('https://alisa.shop/cdn/shop/t/54/assets/fingerprintjsv4.js')
      .then(FingerprintJS => FingerprintJS.load())
      .then(fp => fp.get())
      .then(result => {
        const visitorId = result.visitorId;
        //console.log(visitorId);
        return visitorId; // 返回 visitorId
      })
      .catch(error => {
        //console.error('获取浏览器指纹时出错:', error);
        return null; // 如果发生错误，则返回 null
      });

    // 等待浏览器指纹获取结果
    fpPromise.then(visitorId => {
      // 将visitorId添加到info对象中
      info.visitorId = visitorId;

      // 打印将要发送的数据
      //console.log('Data to be sent:', info);

      // 发送POST请求到visitor.alisa.shop
      return fetch('https://visitor.alisa.shop/api/visitor', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8' // 指定字符编码为UTF-8
        },
        body: JSON.stringify(info)  // 直接将JSON对象转换为字符串并发送
      });
    })

    .then(data => {
      //console.log('向服务器发送成功', data);
    })
    .catch(error => {
      console.error('发送数据时出错:', error);
    });
  })
  .catch(error => {
    console.error('获取IP信息时出错:', error);
  });

